import React, { createContext, ReactNode, useCallback, useState } from "react";

type InternalMapContextType = {
  resetSearchCategory: () => void;
  setResetSearchCategory: (passedMethod: () => void) => void;
};

export const InternalMapContext = createContext<InternalMapContextType>(
  {} as any,
);

export const InternalMapContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [resetSearchCategory, setInternalState] = useState<() => void>(
    () => {},
  );

  const setResetSearchCategory = useCallback(
    (passedMethod: () => void) => {
      setInternalState(() => passedMethod);
    },
    [setInternalState],
  );

  const value = {
    resetSearchCategory,
    setResetSearchCategory,
  };

  return (
    <InternalMapContext.Provider value={value}>
      {children}
    </InternalMapContext.Provider>
  );
};
